import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { OnboardingService } from '../../../../core/services/api/onboarding.service';

@Component({
  selector: 'ling-input-base',
  templateUrl: './input-base.component.html',
  styleUrls: ['./input-base.component.scss'],
})
export class InputBaseComponent {
  @Output() removeButtonPress = new EventEmitter();
  @Output() editButtonPress = new EventEmitter();
  @Input() removeButton = false;
  @Input() isEditButton = false;
  @Input() info = '';
  @Input() editButtonInfo = '';
  @Input() label = '';
  @Input() isRequired = false;
  @HostBinding('class.disabled-input') get isInputDisabled() {
    return this.disabledInput;
  }
  @Input() disabledInput = false;
  private _error = '';
  lastError = '';
  @Input() set error(err: any) {
    this._error = err;
    this.lastError = this.error?.length ? this.error : this.lastError;
  }

  get error(): string {
    return this._error;
  }

  constructor(public onboardingService: OnboardingService) {}

  onRemoveButtonPressed(): void {
    this.removeButtonPress.emit();
  }
}
